import { useEffect, useRef } from "react";
import Lenis from "lenis";

// Momentum smooth-scroll wrapper (Lenis)
export default function SmoothScroll({ children }) {
  const rafRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.5,
    });

    function raf(time) {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    }
    rafRef.current = requestAnimationFrame(raf);

    // expose for anchor scrolling
    window.__lenis = lenis;

    return () => {
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return children;
}
